import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all groups
export const getGroups = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/groups`);
    return response.data;
  } catch (error) {
    console.error("Error fetching groups:", error.response?.data || error);
    throw error;
  }
};

// GET a single group
export const getGroupById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/groups/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching group:", error.response?.data || error);
    throw error;
  }
};

// CHECK if group name exists
export const checkGroupNameExists = async ({ groupName, excludeId } = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/groups/exists`, {      params: { groupName, excludeId },
    });
    return response.data;
  } catch (error) {
    console.error('Error checking group name:', error.response?.data || error);
    throw error;
  }
};

// GET paginated groups
export const getPaginatedGroups = async ({
  page = 1,
  pageSize = 10,
  search = '',
  manufacturerId,
  classId,
} = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/groups/paginated`, {      params: { page, pageSize, search, manufacturerId, classId },
      paramsSerializer: params => {
        const query = new URLSearchParams();
        for (const key in params) {
          const value = params[key];
          if (Array.isArray(value)) {
            value.forEach(v => query.append(key, v));
          } else if (value !== undefined && value !== null && value !== '') {
            query.append(key, value);
          }
        }
        return query.toString();
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching groups:', error.response?.data || error);
    throw error;
  }
};

// CREATE a new group
export const createGroup = async (groupData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/groups`, groupData);
    return response.data;
  } catch (error) {
    console.error("Error creating group:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing group
export const updateGroup = async (id, groupData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/groups/${id}`, groupData);
    return response.data;
  } catch (error) {
    console.error("Error updating group:", error.response?.data || error);
    throw error;
  }
};

// DELETE a group
export const deleteGroup = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/groups/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting group:", error.response?.data || error);
    throw error;
  }
};
